module.exports = __webpack_public_path__ + "img/guide_05.59f935d5.png";